
import { Component, Prop, Vue } from "vue-property-decorator";
import Aside from "@/components/semantics/Aside.vue";
import Header from "@/components/semantics/CenterHeader.vue";
import { Getter } from "vuex-class";
// import NavHeader from "@/components/header/NavHeader.vue";
// import Footer from '@components/footer/Footer.vue';
@Component({
  name: "StationCenter",
  components: {
    Aside,
    Header,
    // Footer,
  },
})
export default class StationCenter extends Vue {}
